import { Injectable } from '@angular/core';
import { environment } from '../../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Observable, of, tap } from 'rxjs';
import { ModuleOption } from '../../models/modulePermission/moduleOption';
import { ModulePermission } from '../../models/modulePermission/modulePermission';
@Injectable({
  providedIn: 'root'
})
export class ModulePermissionServiceService {
private baseUrl = `${environment.apiUrl}/module`;
private cachedModules: Map<number, ModulePermission[]> = new Map();
  constructor(private readonly http: HttpClient) { }

    getAll():Observable<ModulePermission[]> {
           return this.http.get<ModulePermission[]>(this.baseUrl);
         }

           getAllbyUserGroup(id:number):Observable<ModulePermission[]> {
           const cached = this.cachedModules.get(id);
           if (cached) {
             return of(cached);
           }
           return this.http.get<ModulePermission[]>(`${this.baseUrl}/${id}`).pipe(
             tap((modules) => {
               this.cachedModules.set(id, modules);
             })
           );
         }


           saveUserGroupsPermission(data:ModulePermission[]){
            return this.http.post<ModulePermission[]>(`${this.baseUrl}/saveUserGroupOptions`,data).pipe(
             tap((actions) => { 
             })
           );
           }
}
